/**
 * Kasanın tipi. Arka uçta Case.CaseType kolonunda saklanır (DbEnums.CaseType).
 * Banka kasası ayrımı ayrıca BankAccount bağından da türetilir (hasBankAccount);
 * bu enum beyan edilen tiptir ve POS kasasını da kapsar.
 */
export enum CaseType {
    Cash = 0,
    Bank = 1,
    Pos = 2
}
